import { SearchSource } from '@carvana/merch-contracts';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useUserLocation } from '~/context/common/UserContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';

export default function useLogZipCodeChanges() {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { zip } = useUserLocation();
  const previousZip = useRef(zip);
  const trackEvent = useTrackEvent();

  useSubsequentEffect(() => {
    trackEvent('zip code changed', {
      previousZip: previousZip.current,
      newZip: zip
    });
    previousZip.current = zip;
  }, [trackEvent, zip]);

  useSubsequentEffect(() => {
    setSearchSource(SearchSource.Location);
  }, [zip, setSearchSource]);
}
